import moment from 'moment';
import config from 'config';

export default (date) => moment.utc(date).local().format(config.dateFormat);
